/* eslint-disable no-console */

import URI from "URIjs/URI";
import "URIjs/URI.fragmentQuery";

/*
  Extract an employee id from an optional "employee" param of
  the form "empl_<id>".
*/
function employeeIdFromEmployeeParam (param) {
  if (param === undefined) {
    return undefined;
  }

  const prefix = "empl_";
  if (!param.startsWith(prefix)) {
    console.warn(`Expected employee param '${param}' to start with '${prefix}'`);
    return undefined;
  }

  return param.substr(prefix.length);
}

/*
  Extract a service id, and one or more option ids, from an "item" param value.
  The ids are comma separated, each of the form "serv_<id>" or "sopt_<id>".
  For example "srvc_560819,sopt_3915547,sopt_391589" .

  Return an object in the form expected by the backbone model.
*/
function serviceFromItemParam (param) {
  const servicePrefix = "srvc_";
  const optionPrefix = "sopt_";

  let serviceId;
  const optionIds = [];

  param
    .split(",")
    // trim white space from part
    .map((part) => part.trim())
    // drop any empty parts
    .filter((part) => part.length > 0)
    // each part should be either a service or an option
    .forEach((part) => {
      if (part.startsWith(servicePrefix)) {
        // extract service id
        if (serviceId === undefined) {
          serviceId = parseInt(part.substr(servicePrefix.length), 10);
        } else {
          console.warn(`Multiple service ids in '${param}'; ignored '${part}'`);
        }
      } else if (part.startsWith(optionPrefix)) {
        // add an option id
        const optionId = parseInt(part.substr(optionPrefix.length), 10);
        optionIds.push(optionId);
      } else {
        console.warn(`Unrecognised part in item param '${param}'; ignored '${part}'`);
      }
    })
  ;

  // Verify that we have a service id.
  if (serviceId === undefined) {
    console.warn(`No service id in item param '${param}'; parameter ignored`);
    return undefined;
  }

  // Verify that we have at least one option id.
  if (optionIds.length === 0) {
    console.warn(`No options ids in item param '${param}'; parameter ignored`);
    return undefined;
  }

  return {
    serviceId,
    skus: optionIds.map((optionId) => ({ choiceId: optionId }))
  };
}

/*
  There may be multiple "item" parameters, each of which should
  hold a service id and one or more option ids.

  Return an array of objects, each inthe form expected by the
  backbone model.
*/
function servicesFromItemParams (params) {
  if (params === undefined) {
    console.warn("No basket 'item' parameters");
    return undefined;
  }

  const items = (Array.isArray(params) ? params : [params]);
  const services = items
    // Convert item param to object expect by the backbone model.
    .map(serviceFromItemParam)
    // Drop any item params that did provide a service or option.
    // Messages will have been written to console by serviceFromItemParam.
    .filter((service) => service !== undefined)
  ;

  // Expect at least one service.
  if (services.length === 0) {
    console.warn(`No valid services in item parameters '${items}'`);
    return undefined;
  }

  return services;
}

export function basketFromUriParams () {
  const uri = new URI(window.location.href).fragmentPrefix("");
  const fragmentParams = uri.fragment(true);

  return {
    services: servicesFromItemParams(fragmentParams.item),
    employeeId: employeeIdFromEmployeeParam(fragmentParams.employee)
  };
}
